import { RefObject, useEffect, useState } from 'react';

export function useElementOnScreen(
	ref: RefObject<Element>,
	rootMargin = '0px'
) {
	const [isIntersecting, setIsIntersecting] = useState(true);
	useEffect(() => {
		const currentElement = ref.current;
		const observer = new IntersectionObserver(
			([entry]) => {
				setIsIntersecting(entry.isIntersecting);
			},
			{ rootMargin }
		);

		if (currentElement) {
			observer.observe(currentElement);
		}

		return () => {
			if (currentElement) {
				observer.unobserve(currentElement);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return isIntersecting;
}
